var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCardIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 69,
    viewBox: "0 0 77 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_110_176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.4 23.1401H11.32C5.62042 23.1401 1 27.7606 1 33.4601V57.6601C1 63.3597 5.62042 67.9801 11.32 67.9801H53.4C59.0996 67.9801 63.72 63.3597 63.72 57.6601V33.4601C63.72 27.7606 59.0996 23.1401 53.4 23.1401Z",
    stroke: "#12574D",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 36.1899H63.72",
    stroke: "#12574D",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.43 50.36C64.0604 50.36 75.11 39.3104 75.11 25.68C75.11 12.0496 64.0604 1 50.43 1C36.7996 1 25.75 12.0496 25.75 25.68C25.75 39.3104 36.7996 50.36 50.43 50.36Z",
    fill: "white",
    stroke: "#12574D",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8096 24.0302L45.8496 30.6202L61.0496 20.7402",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8096 24.0302L45.8496 30.6202L61.0496 20.7402",
    stroke: "#12574D",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_110_176"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.11,
    height: 68.98,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardIcon);
export default __webpack_public_path__ + "static/media/card-icon.b6f27bf8.svg";
export { ForwardRef as ReactComponent };